import getDefaultFolderIdToLoad from 'mini-mail-folder-store/lib/utils/getDefaultFolderIdToLoad';
import { action } from 'satcheljs/lib/legacy';
import { selectFolderInternal } from './selectFolder';

export default action('selectDefaultFolder', { datapoint: { name: 'selectDefaultFolder' } })(
    function selectDefaultFolder(): void {
        // Call selectFolderInternal here to separate datapoint selectDefaultFolder from selectFolder
        selectFolderInternal(getDefaultFolderIdToLoad());
    }
);
